import(/* webpackMode: "eager" */ "/app/apps/web/src/components/landing/AuthTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GeneratorPanel"] */ "/app/apps/web/src/components/landing/GeneratorPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroVisual"] */ "/app/apps/web/src/components/landing/HeroVisual.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IdeasMasonry"] */ "/app/apps/web/src/components/landing/IdeasMasonry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingAuthRedirect"] */ "/app/apps/web/src/components/landing/LandingAuthRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/apps/web/src/components/landing/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrendsCarousel"] */ "/app/apps/web/src/components/landing/TrendsCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@opentelemetry+api@1.9.0_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/next/dist/client/image-component.js");
